import { ScrollToTop } from "@/core/layout/ScrollToTop/ScrollToTop.ts";
import { FC, PropsWithChildren, ReactNode } from "react";

type ContentSize = "normal" | "full";

interface IPageContentProps {
    /**
     * Optional render slot for sidebar content
     */
    sidebarSlot?: ReactNode;
    /**
     * Optional render slot for banner content
     */
    bannerSlot?: ReactNode;
    /**
     * Size of main content container
     */
    contentSize?: ContentSize;
}

export const PageContent: FC<IPageContentProps & PropsWithChildren> = ({
    sidebarSlot,
    bannerSlot,
    contentSize = "normal",
    children,
}) => {
    function renderSlot(slot: ReactNode) {
        if (!slot) {
            return null;
        }
        return <>{slot}</>;
    }

    return (
        <div className="row">
            <ScrollToTop />
            <div className="col-18 col-xxl-4">
                <aside className="sidebar-wrapper mt-5" data-testid="aside-container">
                    {renderSlot(sidebarSlot)}
                </aside>
            </div>
            <div className="col-18 col-xxl-14">
                <main data-testid="main-container">
                    <div className="banner-wrapper">{renderSlot(bannerSlot)}</div>
                    <div className="row mt-5">
                        <div className={"col-18 " + (contentSize === "normal" ? "col-xl-13" : "")}>{children}</div>
                    </div>
                </main>
            </div>
        </div>
    );
};
